import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useAuth } from '../contexts/auth/hooks';

export default function Header({ className = '' }: { className?: string }) {
  const { business } = useAuth();
  const [logoError, setLogoError] = useState(false);

  // נתוני העסק (לוגו + ראשי תיבות)
  const brand = useMemo(() => {
    const name = business?.name || 'LoyalFlow';
    const logo = (business as any)?.logoUrl as string | undefined;
    const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
    return { name, logo, initials };
  }, [business]);

  return (
    <>
      {/* ההדר: אין כאן position—העמדה מבחוץ ע"י className */}
      <header className={`app-header-contents ${className}`}>
        <div className="max-w-7xl mx-auto px-4" style={{ height: 'var(--header-height)' }}>
          <div className="h-full flex items-center justify-between">
            {/* אווטר עסק בצד ימין (לוגו בעיגול, נופל לראשי תיבות) */}
            <Link
              to="/settings"
              className="w-10 h-10 rounded-xl bg-white border border-gray-100 shadow-sm overflow-hidden grid place-items-center order-2"
              aria-label="הגדרות העסק"
            >
              {brand.logo && !logoError ? (
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full object-cover"
                  onError={() => setLogoError(true)}
                  referrerPolicy="no-referrer"
                />
              ) : (
                <span className="text-sm font-semibold text-gray-700">{brand.initials}</span>
              )}
            </Link>
            {/* מרכז: לוגו LoyalFlow + טקסט */}
            <div className="min-w-0 text-center flex items-center justify-center gap-2 mx-auto order-1">
              <img src="/vite.svg" alt="LoyalFlow" className="w-5 h-5" />
              <div className="text-[16px] font-semibold text-gray-900">LoyalFlow</div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}